module.exports = __webpack_public_path__ + "static/media/express.19ef606c.png";